import React, { useState } from "react";
import Navbar from "./components/navbar/Navbar";
import UseDarkSide from "./components/switcher/UseDarkSide";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Detail from "./components/detail/Detail";
import Home from "./pages/Home";
import Authors from "./components/authors/Authors";
import Authorsblogs from "./components/authorsblogs/Authorsblogs";
import Footer from "./components/footer/Footer";

const App = () => {
  const [colorTheme, setTheme] = UseDarkSide();
  const [darkSide, setDarkSide] = useState(
    colorTheme === "light" ? true : false
  );
  const toggleDarkMode = (checked) => {
    setTheme(colorTheme);
    setDarkSide(checked);
  };
  return (
    <>
      <Router>
        <Navbar darkSide={darkSide} toggleDarkMode={toggleDarkMode} />
        <Routes>
          <Route
            path="/"
            exact
            element={
              <Home darkSide={darkSide} toggleDarkMode={toggleDarkMode} />
            }
          />
          <Route path="/detail" exact element={<Detail />} />
          <Route path="/authors" exact element={<Authors />} />
          <Route path="/authors/blogs" exact element={<Authorsblogs />} />
        </Routes>
        <Footer />
      </Router>
    </>
  );
};

export default App;
